export const materialType = [
  { value: 'FR4', text: 'FR4 Tg135' },
  { value: 'FR4TG175', text: 'FR4 Tg175' },
];

export const numberLayer = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
  { value: 6, text: '6' },
  { value: 8, text: '8' },
];

export const materialThickness = [
  { value: '0.125', text: '0.125"' },
  { value: '0.094', text: '0.094"' },
  { value: '0.080', text: '0.080"' },
  { value: '0.062', text: '0.062"' },
  { value: '0.031', text: '0.031"' },
];

export const finishPlating = [
  { value: 'Leaded Solder', text: 'Leaded Solder' },
  { value: 'Lead Free Solder', text: 'Lead Free Solder' },
  // { value: 'Bare Copper', text: 'Bare Copper' },
  { value: 'ENIG', text: 'ENIG' },
  { value: 'OSP', text: 'OSP' },
  { value: 'Carbon Ink', text: 'Carbon Ink' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
  { value: 'Immersion Tin', text: 'Immersion Tin' },
  { value: 'Peelable Mask', text: 'Peelable Mask' },
];

export const cooperInner = [
  { value: '0.5 oz', text: '0.5 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const cooperOuter = [
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];
